<template>
  <div class="mui-group-item">
    <div class="mui-group-item-hd">
      <label class="mui-label" :style="{width: labelWidth || defaultLabelWidth + 'em'}" v-if="title">{{title}}</label>
      <inline-desc v-if="inlineDesc">{{inlineDesc}}</inline-desc>
    </div>
    <div class="mui-group-item-bd mui-group-item-primary">
      <input
      class="mui-input"
      :type="type"
      :pattern="pattern"
      :placeholder="placeholder"
      :disabled="disabled"
      :maxlength="maxlength"
      @blur="handlerBlur"
      @focus="handlerFocus"
      v-model="value"
      v-el:input/>
    </div>
    <div class="mui-group-item-ft">
      <i class="mui-icon mui-icon-clear mui-large-touch-area" v-show="showClear && value" @click="clear"></i>
    </div>
  </div>
</template>

<script>
import Base from '../../libs/base'
import InlineDesc from '../inline-desc/'

export default {
  ready () {
    if (!this.title && !this.placeholder) {
      console.warn('no title and no placeholder?')
    }
  },
  mixins: [Base],
  components: {
    InlineDesc
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    labelWidth: {
      type: String,
      default: ''
    },
    inlineDesc: {
      type: String
    },
    placeholder: {
      type: String
    },
    value: {
      type: [String, Number],
      default: ''
    },
    keyboard: {
      type: String
    },
    maxlength: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'text'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    pattern () {
      if (this.keyboard === 'number') {
        return '[0-9]*'
      }
    },
    defaultLabelWidth () {
      return this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1
    }
  },
  methods: {
    clear () {
      this.value = ''
      this.focus = true
      let event = document.createEvent('HTMLEvents')
      event.initEvent('input', true, false)
      this.$els.input.value = ''
      this.$els.input.dispatchEvent(event)
    },
    handlerBlur () {
      this.setTouched()
      this.$dispatch('blur')
    },
    handlerFocus () {
      this.$dispatch('focus')
    }
  },
  data () {
    let data = {
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      focus: false
    }
    return data
  },
  watch: {
    focus (newVal) {
      if (newVal) {
        this.$els.input.focus()
      }
    }
  }
}
</script>

<style lang="less">
@import (reference) "../group-item/style.less"; // 引入group-iem样式
@import "./style.less";
</style>



/** WEBPACK FOOTER **
 ** index.vue?a397711e
 **/